export function formatGeneratedTime(dateString: string | null) {
  if (!dateString) return null;
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "Generated just now";
  if (diffMins < 60) return `Generated ${diffMins} min ago`;
  if (diffHours < 24) return `Generated ${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
  return `Generated ${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
}
